export default "__VITE_ASSET__B0BaQnm5__"